import { NgModule } from '@angular/core';

import { ApiService }          from './api.service';
import { CacheService }        from './cache.service';
import { StreamSearchService } from './stream-search.service';

@NgModule({
  providers: [
    ApiService,
    CacheService,
    StreamSearchService
  ]
})
export class ApiModule {}
